const routes = [
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import('./views/index.vue'),
    meta: {
      title: 'Задачи',
    },
  },
  {
    path: '/tasks/:id',
    name: 'task',
    component: () => import('./views/Task.vue'),
  },
  {
    path: '/create-task',
    name: 'create-task',
    component: () => import('./views/CreateTask'),
  },
  {
    path: '/dotdotdot',
    name: 'd',
    component: () => import('./components/GroupFiles'),
  },
];

export default routes;
